import React from "react";
import { useClasses } from "../../..";
import classNames from "classnames";
const styles = (theme) => {
    return {
        suggestHolder: {
            position: "relative",
        },
        suggestList: {
            position: "absolute",
            padding: "0px",
            backgroundColor: "#fff",
            width: "calc(100%)",
            boxShadow: "0px 5px 8px 0px rgba(50, 50, 50, 0.75)",
            top: 0,
            margin: 0,
            listStyle: "none",
            maxHeight: "300px",
            overflowY: "scroll",
            zIndex: 1,
        },
        suggestItem: {
            padding: "8px 16px",
            "&:hover": {
                color: "#fff",
                backgroundColor: theme.palette.get("primary"),
                cursor: "pointer",
            },
        },
    };
};
export default function Suggestions(props) {
    const { suggestions, override, onSelect } = props;
    const classes = useClasses(styles);
    if (Array.isArray(suggestions) && suggestions.length > 0)
        return (React.createElement("div", { className: classes.suggestHolder },
            React.createElement("ul", { className: classNames([classes.suggestList, override === null || override === void 0 ? void 0 : override.suggestList]) }, suggestions.map((item) => (React.createElement("li", { key: `input-suggest-${item}`, tabIndex: 0, className: classNames([
                    classes.suggestItem,
                    override === null || override === void 0 ? void 0 : override.suggestItem,
                    props.identifyer,
                ]), onClick: (e) => {
                    e.preventDefault();
                    if (onSelect)
                        onSelect(item);
                } }, item))))));
    return null;
}
